import React from 'react';
import { AD_STATUS } from './admin.constants';

export function statusDotColor(status: string): string {
  const p = AD_STATUS[status];
  return p ? p.fg : '#94a3b8';
}

export function StatusBadge({ status }: { status: string }) {
  const p = AD_STATUS[status];
  if (!p) return null;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 8px', borderRadius: 6, background: p.bg, color: p.fg, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
      {p.label}
    </span>
  );
}
